import ReConnectWinner from '@containers/IQOSUniverse/articles/ReConnectWinner/ReConnectWinner';
export default ReConnectWinner;
